import { WebApiMemberDtoMemberHistoryDto } from "../Repository/eventbookyapi";
import { TextService } from "../Services/TextService";
import { HistoryEventType } from "../Types/HistoryEventTypes";
import { mapHistoryEventTypeToText } from "./mapHistoryEvents";

export const mapHistoryeToText = (history: WebApiMemberDtoMemberHistoryDto) => {
    const GetText = TextService.GetText;

    switch (Number(history.type)) {
        case HistoryEventType.AddMember:
            return history.createdByName + GetText("History_Added") + history.memberName + GetText("History_AsMember");
        case HistoryEventType.DeleteMember:
            return history.createdByName + GetText("History_Removed") + history.memberName + GetText("History_AsMember");
        case HistoryEventType.UpdatedMemberProperties:
            return history.createdByName + GetText("History_Updated") + history.memberName + GetText("History_ContactDetails")
        case HistoryEventType.UpdatedMemberPropertiesByMember:
            return history.memberName + GetText("History_ContactDetailsUpdate")
        case HistoryEventType.AddMemberByMember:
            return history.memberName + GetText("History_RegistredAsMember")
        case HistoryEventType.MemberIsActivated:
            return history.memberName + GetText("History_ActivatedAccount")
        case HistoryEventType.CreatedCustomListItem:
        case HistoryEventType.UpdatedCustomListItem:
        case HistoryEventType.DeletedCustomListItem:
        case HistoryEventType.CustomListItemMemberConnectionChanged:
        case HistoryEventType.CreatedCustomListItemByMember:
        case HistoryEventType.UpdatedCustomListItemByMember:
        case HistoryEventType.DeletedCustomListItemByMember:
        case HistoryEventType.CustomListItemMemberConnectionChangedByMember:
            return mapHistoryEventTypeToText(Number(history.type));
        default:
            return GetText("Common_UnknownAction");
    }
}